class MyStorage {
    constructor(prefix) {
        this.prefix = prefix || 'myApp_';
    }

    save(key, data) {
        const prefixedKey = this.prefix + key;
        localStorage.setItem(prefixedKey, JSON.stringify(data));
    }

    get(key, defaultValue = null) {
        try {
            const prefixedKey = this.prefix + key;
            const data = localStorage.getItem(prefixedKey);
            return data ? JSON.parse(data) : defaultValue;
        } catch (e) {
            console.error(e);
            return defaultValue;
        }
    }

    remove(key) {
        const prefixedKey = this.prefix + key;
        localStorage.removeItem(prefixedKey);
    }

    clear() {
        Object.keys(localStorage).forEach((key) => {
            if (key.startsWith(this.prefix)) {
                localStorage.removeItem(key);
            }
        });
    }

    async remember(key, callback, defaultValue = null) {
        let data = this.get(key, defaultValue);
        if (!data) {
            data = await callback();
            this.save(key, data);
        }
        return data;
    }
}

const myStorage = new MyStorage('fb_tools_');
window.myStorage = myStorage;
export default myStorage;